export const getRoundedTemperature = (value: number | string, points: 1 | 2, keepDecimals = false) => {
  const roundedValue = Number(value).toFixed(points)
  return keepDecimals ? roundedValue : roundedValue.replace(points === 1 ? ".0" : ".00", "")
}
